module.exports = __webpack_public_path__ + "img/pdf.fd17fc0f.png";